export const headers = () => {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }
    }
}

export const headersWithToken = (token) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }
    }
}

export const headersWithImage = (token) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*'
        }
    }
}

export const responseError = (e) => {
    let data = [];
    if (e.response.data.statusCode === 401) {
        data.push({ message: e.response.data.message, color: 'warning' });
    }

    else if (e.response.data.statusCode === 409) {
        e.response.data.errors.map((val) => {
            data.push({ message: val, color: 'warning' });
        });
    }

    else if (e.response.data.statusCode === 422 || e.response.data.statusCode === 405) {
        data.push({ message: e.response.data.errors, color: 'warning' });
    }

    else if (e.response.data.statusCode === 400 && e.response.data.errors) {
        for (let key in e.response.data.errors) {
            if (e.response.data.errors.hasOwnProperty(key)) {
                data.push({
                    message: e.response.data.errors[key][0],
                    color: 'warning'
                });
            }
        }
    }

    else if (e.response.data.statusCode === 404) {
        data.push({ message: e.message, color: 'info' });
    }

    else {
        data.push({ message: e.message, color: 'danger' });
    }
    return data;
}

// live url
// export const site_url = 'https://admin.predictiondog.com/api';

// base url
// export const site_url = 'http://localhost/prediction-dog/public/api';
export const site_url = 'https://admin.predictiondog.com/api';

export const Login = `${site_url}/auth/login`;
export const SignUp = `${site_url}/auth/store`;
export const Contact = `${site_url}/contactStore`;
export const ForgotPassword = `${site_url}/auth/forgot-password`;
export const ProfileUpdate = `${site_url}/user/update`;
export const ChangePassword = `${site_url}/user/changePassword`;
export const StaticPages = `${site_url}/showPages`;
export const ShowTicker = `${site_url}/showTicker`;
export const ShowPodcast = `${site_url}/showPodcast`;
export const ShowBlog = `${site_url}/showBlog`;
export const ShowPremiumTips = `${site_url}/tip/getPremiumTip`;
export const ShowFreeTips = `${site_url}/tip/getFreeTip`;
export const showTestimonial = `${site_url}/showTestimonial`;
export const logoutDelToken = `${site_url}/user/logout`;
export const ShowPackages = `${site_url}/showPackage`;
export const showCategory = `${site_url}/showCategory`;
export const addCard = `${site_url}/user/AddCard`;
export const subscribe_url = `${site_url}/user/subscribe`;
export const renewVenmoUrl = `${site_url}/user/renew-venmo`;
export const cancelSubscription = `${site_url}/user/UpgradeSubscribe`;
export const UpgradeSubs = `${site_url}/user/CancelSubscription`;
export const ResetPassword = `${site_url}/auth/reset-password`;
export const infoAfterLogin = `${site_url}/user/info`;
export const newsLetterUrl = `${site_url}/newsletterStore`;
export const getSiteMap = `${site_url}/getSiteMap`;
export const SiteSettingsUrl = `${site_url}/getSiteSettings`;
export const CurrentSubsUrl = `${site_url}/user/current-subscription`;